import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Card } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Subscription from "~/models/Subscription/Subscription";

@observer
class SubscriptionCanceledCardDescription extends Component {
  render() {
    const { t, subscription } = this.props;

    if (subscription.canceledDts === null) {
      return null;
    }

    return (
      <Card.Description>
        {t("billingCentral:subscriptionWasActiveFromTo", {
          dateFrom: subscription.creationDts.format("MMMM Do YYYY"),
          dateTo: subscription.canceledDts.format("MMMM Do YYYY"),
        })}
      </Card.Description>
    );
  }
}

SubscriptionCanceledCardDescription.propTypes = {
  t: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
};

export default withTranslation()(SubscriptionCanceledCardDescription);
